<script setup lang="ts">
defineProps<{
  type?: string // not in use
  label?: string
  name: string
  required?: boolean
}>()
</script>

<template>
  <div class="flex flex-col gap-2 font-mono text-sm uppercase">
    <label :for="name">
      <span>{{ label }} ({{ required ? 'Required' : 'Optional' }})</span>
    </label>

    <input
      :id="name"
      :name="name"
      :required="required"
      placeholder="Select a file"
      class="block w-full cursor-pointer border px-3 py-5 text-sm text-gray-900 focus:outline-none"
      type="file"
    />
  </div>
</template>
